import { selectCommunication } from 'actions';
import { changeTranslationMode } from 'actions/envelopeView';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getSelectedCommunication } from 'selectors/communications';
import { getOriginalCommunication, getTranslationCommunication } from 'selectors/envelopeReview';
import { getOpenAttachmentState } from 'selectors/envelopeView';
import { getUserPreferOriginalLanguages } from 'selectors/users';
import { useSelector } from 'store';
import { getLikelyLanguage, shouldPreferOriginal } from 'utils/userMetadata';

const AttachmentTranslation: React.FC = () => {
  const dispatch = useDispatch();
  const openAttachment = useSelector(getOpenAttachmentState);
  const preferOriginalLanguages = useSelector(getUserPreferOriginalLanguages);

  const selectedCommunication = useSelector(getSelectedCommunication);
  const parentId = selectedCommunication?.meta_data?.parent_communication_uuid ?? '';

  const originalCommunication = useSelector((state) => getOriginalCommunication(state, parentId));

  const attachmentTranslation = useSelector((state) =>
    getTranslationCommunication(state, openAttachment)
  );

  const showingTranslation = selectedCommunication?.uuid === attachmentTranslation?.uuid;
  const preferOriginal = shouldPreferOriginal(
    preferOriginalLanguages,
    getLikelyLanguage(originalCommunication) ||
      getLikelyLanguage(selectedCommunication) ||
      getLikelyLanguage(attachmentTranslation)
  );

  if (!attachmentTranslation) {
    return null;
  }

  const handleTranslation = (): void => {
    if (openAttachment && attachmentTranslation) {
      dispatch(selectCommunication({ communication: attachmentTranslation }));
      if (!preferOriginal) {
        dispatch(changeTranslationMode(true));
      }
    }
  };

  const handleCommunication = (): void => {
    if (openAttachment && originalCommunication) {
      dispatch(selectCommunication({ communication: originalCommunication }));
      if (!preferOriginal) {
        dispatch(changeTranslationMode(false));
      }
    }
  };

  return (
    <div className="text-small leading-4">
      <button
        type="button"
        disabled={showingTranslation}
        className={`focus:outline-none ${
          !showingTranslation ? 'text-litlingo-primary cursor-pointer underline' : ''
        }`}
        onClick={handleTranslation}
      >
        Translation
      </button>

      <span> | </span>
      <button
        type="button"
        disabled={!showingTranslation}
        className={`focus:outline-none ${
          showingTranslation ? 'text-litlingo-primary cursor-pointer underline' : ''
        }`}
        onClick={handleCommunication}
      >
        Original
      </button>
    </div>
  );
};

export default AttachmentTranslation;
